import api from '../config/api'
import {
  ActiveChannelsResponse,
  DismissResponse,
  ForceStopResponse,
  GcpChannelsResponse,
  GcpInputsResponse,
  HealthCheckResponse,
  RetryResponse,
  RoomGcpStatusResponse,
  StreamingListFilters,
  StreamingListResponse,
  StreamingProvisionedStatusResponse,
} from '../streaming-management/types'

const getRoomGcpStatus = (roomId: number) => {
  return api.get<RoomGcpStatusResponse>(`/management/rooms/${roomId}/gcp/status`)
}

const getHealthCheck = (roomId: number) => {
  return api.get<HealthCheckResponse>(`/management/rooms/${roomId}/gcp/health-check`)
}

const getActiveChannels = (checkGcp = false) => {
  return api.get<ActiveChannelsResponse>(`/management/channels/active`, {
    params: { check_gcp: checkGcp ? 1 : 0 },
  })
}

const getStreamings = (filters: StreamingListFilters = {}) => {
  const params: Record<string, any> = {}
  if (filters.status) params.status = filters.status
  if (filters.entity_id) params.entity_id = filters.entity_id
  if (filters.event_id) params.event_id = filters.event_id
  if (filters.room_id) params.room_id = filters.room_id
  if (filters.from) params.from = filters.from
  if (filters.to) params.to = filters.to
  if (filters.per_page) params.per_page = filters.per_page
  if (filters.page) params.page = filters.page
  return api.get<StreamingListResponse>('/management/streamings', { params })
}

const forceStop = (streamingId: string) => {
  return api.post<ForceStopResponse>(`/management/streamings/${streamingId}/force-stop`)
}

const retry = (streamingId: string) => {
  return api.post<RetryResponse>(`/management/streamings/${streamingId}/retry`)
}

const dismiss = (streamingId: string) => {
  return api.post<DismissResponse>(`/management/streamings/${streamingId}/dismiss`)
}

const getStreamingProvisionedStatus = (streamingId: string) => {
  return api.get<StreamingProvisionedStatusResponse>(
    `/management/streamings/${streamingId}/gcp/provisioned-status`,
  )
}

const deprovisionStreaming = (streamingId: string) => {
  return api.delete(`/management/streamings/${streamingId}/gcp/provision`)
}

const transcode = (streamingId: string) => {
  return api.post(`/management/streamings/${streamingId}/transcode`)
}

const getGcpInputs = () => {
  return api.get<GcpInputsResponse>('/management/gcp/inputs')
}

const deleteGcpInput = (inputId: string) => {
  return api.delete(`/management/gcp/inputs/${encodeURIComponent(inputId)}`)
}

const getGcpChannels = () => {
  return api.get<GcpChannelsResponse>('/management/gcp/channels')
}

const deleteGcpChannel = (channelId: string) => {
  return api.delete(`/management/gcp/channels/${encodeURIComponent(channelId)}`)
}

const StreamingManagementService = {
  getRoomGcpStatus,
  getHealthCheck,
  getActiveChannels,
  getStreamings,
  forceStop,
  retry,
  dismiss,
  getStreamingProvisionedStatus,
  deprovisionStreaming,
  transcode,
  getGcpInputs,
  deleteGcpInput,
  getGcpChannels,
  deleteGcpChannel,
}

export default StreamingManagementService
